import { ErrorType } from "~/enums/ErrorType";
import { ValidationErrorMessage } from "~/enums/validationErrorMessage";
import NavigableValidator from "~/models/navigableValidators/navigableValidator";

export default class ObjectModelRelationshipPresenceValidator<T> extends NavigableValidator<T> {
  defaultMessage = ValidationErrorMessage.MustBePresent;
  defaultType =  ErrorType.mustBePresent;

  _validate(model): void {
    // relation is inverse or non-inverse
    const relation = model._rootModel.allRelations.find(r => r.client_id === model[this.field])
    if (!relation) {
      this.errors.push(this.buildValidationError(model, model[this.field], this.field));
    }
  }
}